<template>
<view>
  <view
    class="list"
    wx:for="{{list}}"
    wx:key="name"
    class="item {{list.length - 1 === index && !showFooterBtn ? 'no-border' : ''}}"
    wx:style="{{itemStyle}}"
  >
    <view class="item-header">
      <view class="item-name">{{item.shop_name}}</view>
      <view>
        <text class="item-distance">{{item.distance_desc}}</text>
        <view class="item-guide" bindtap="goDetail(item)"><image class="icon-guide" src="https://ut-static.udache.com/webx/ut/V7wGh8vQW81jACg4d9Ngv.png"/>导航</view>
      </view>
    </view>
    <view class="item-price" wx:style="{{priceLabelStyle}}" wx:for="{{goodsList}}" wx:for-item="goodItem" wx:key="id">
      <view class="service_name">{{goodItem.service_name}}</view>
      <view class="price-original">
        <view class="label" wx:style="{{priceStyle}}">门店价:
          <text>¥{{goodItem.price}}</text>
        </view>
        <view class="price-vip-label">优惠价:</view>
      </view>
      <view class="price-vip">
        <text class="value"><text class="unit">¥</text>{{ goodItem.best_price }}</text>
      </view>
      <view class="buy-it" bindtap="goDetail(item)">购买</view>
    </view>
  </view>
</view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { post, is, bridge, build, xenv, trackEvent } from '@didi/webx-js'

createComponent({
  name: 'car-wash-list',
  properties: {
    list: {
      type: Array,
      value: []
    },
    showFooterBtn: {
      type: Boolean,
      value: true,
    },
    styleConfig: {
      type: Object,
      value: {}
    }
  },
  data: {
  },
  computed: {
    priceLabelStyle() {
      return { color: this.styleConfig.labelColor }
    },
    priceStyle() {
      return { color: this.styleConfig.priceColor }
    },
    itemStyle() {
      return { borderColor: this.styleConfig.borderColor }
    },
    goodsList() {
      const lists = this.list.length && this.list[0]?.goods_list // 第一个门店下的商品
      if (lists) {
        let goodsListNew = lists.map(item => {
          item.best_price = Math.round(item.best_price / 100 * 100) / 100
          return item
        })
        return goodsListNew.slice(0, 2)
      }
      return []
    },
  },
  methods: {
    goDetail(item) {
      this.triggerEvent('goToDetail', item)
    }
  }
})
</script>

<style lang="stylus" scoped>
@font-face {
  font-family: 'DIN-BlackItalic';
  src: url('https://img-hxy021.didistatic.com/static/utfe/do1_l1Sw5zCiLssbdzlZQI12');
}
border-1px(border = bottom, color = #ccc, radius = 0, style = solid)
  position: relative
  &:after
    content: ""
    pointer-events: none // 解决iphone上的点击无效Bug
    display: block
    position: absolute
    left: 0
    top: 0
    transform-origin: 0 0
    if border is all
      border: 1px style color
    else
      border-{border}: 1px style color
    box-sizing border-box
    border-radius: radius
    width 100%
    height 100%
    @media (-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2)
      width: 200%
      height: 200%
      border-radius: radius * 2
      transform: scale(.5) translateZ(0)
    @media (-webkit-min-device-pixel-ratio: 3), (min-device-pixel-ratio: 3)
      width: 300%
      height: 300%
      border-radius: radius * 3
      transform: scale(.33) translateZ(0)
.item
  padding 20rpx 0 30rpx
  border-bottom: 1px dashed #C63200;
  &.no-border
    border-bottom none
  .item-header
    display flex
    margin-bottom 20rpx
    .item-name
      flex 1
      width 428rpx
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
    .item-name, .item-distance
      height: 48rpx;
      font-family: PingFangSC-Regular;
      font-size: 34rpx;
      color: #1B1B1B;
      font-weight: 400;
    .item-distance, .item-guide
      display inline-block
    .item-guide
      font-family: PingFangSC-Regular;
      font-size: 26rpx;
      color: #000000;
      padding-left 18rpx
      .icon-guide
        position relative
        top 2rpx
        right 2rpx
        width 26rpx
        height 26rpx
  .item-price
    display flex
    align-items: center;
    justify-content: space-between
    margin-top 32rpx
    color: #B6631D;
    .service_name
      height: 40rpx;
      font-family: PingFangSC-Medium;
      font-size: 24rpx;
      color: #1B1B1B;
      font-weight: 500;
    .buy-it
      width: 120rpx;
      height: 40rpx;
      line-height 40rpx;
      border-1px(all, rgba(224,45,24,1), 20rpx)
      // border: 1rpx solid rgba(224,45,24,1);
      // border-radius: 20rpx;
      font-family: PingFangSC-Regular;
      font-size: 24rpx;
      color: #E02D18;
      font-weight: 400;
      text-align center
    .label
      font-family: PingFangSC-Medium;
      font-weight: 600
      font-size: 22rpx;
    .price-vip > .value
      font-family: DIN-BlackItalic;
      font-weight: bold
      font-size: 40rpx;
      color: #E02D18;
      letter-spacing: 0;
      line-height: 60rpx;
      position relative
      .unit
        padding-right 8rpx
        font-size: 30rpx;
    .price-original
      padding-left 30rpx
      .label
        text-decoration:line-through
      .price-vip-label
        font-family: PingFangSC-Medium;
        font-weight: 600
        font-size: 20rpx;
        color: #E02D18;
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {}
}
</script>
